__webpack_require__.p = "https://bmidxbmalaysiaplpreprod.netlify.app/";